export interface DebugData {
  fps: number;
  ping: number;
  clockOffsetMs: number;
  position: { x: number; y: number; z: number };
  targetId: string | null;
  targetOwner: string | null;
  globalState: string;
  videoReady: boolean;
  videoBufferedSeconds: number;
  videoSyncErrorMs: number | null;
}

/** Development-only overlay (see spec section 32/40). Not mounted in production builds. */
export class DebugPanel {
  private el: HTMLDivElement;
  private visible = false;

  constructor(container: HTMLElement) {
    this.el = document.createElement("div");
    this.el.id = "debug-panel";
    this.el.classList.add("hidden");
    container.appendChild(this.el);
  }

  setVisible(visible: boolean): void {
    this.visible = visible;
    this.el.classList.toggle("hidden", !visible);
  }

  toggle(): void {
    this.setVisible(!this.visible);
  }

  update(data: DebugData): void {
    if (!this.visible) return;
    this.el.textContent = [
      `FPS: ${data.fps.toFixed(0)}`,
      `PING: ${data.ping}ms`,
      `CLOCK OFFSET: ${data.clockOffsetMs >= 0 ? "+" : ""}${data.clockOffsetMs.toFixed(0)}ms`,
      `POS: ${data.position.x.toFixed(1)}, ${data.position.y.toFixed(1)}, ${data.position.z.toFixed(1)}`,
      `TARGET ID: ${data.targetId ?? "-"}`,
      `TARGET OWNER: ${data.targetOwner ?? "-"}`,
      `GLOBAL STATE: ${data.globalState}`,
      `VIDEO READY: ${data.videoReady}`,
      `VIDEO BUFFER: ${data.videoBufferedSeconds.toFixed(1)}s`,
      `SYNC ERROR: ${data.videoSyncErrorMs === null ? "-" : `${data.videoSyncErrorMs}ms`}`,
    ].join("\n");
  }

  dispose(): void {
    this.el.remove();
  }
}
